import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { onBeforeUnmount, onMounted, watch } from "vue";
import { computed } from "vue";
import store from "@/store";
import { OVERLAY_KEYBOARD } from "@/utils/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'baseForm',
  props: {
  show: { type: Boolean, default: false },
  enterEvent: { type: Boolean, default: false },
},
  emits: ["on:submit"],
  setup(__props, { emit }) {

const props = __props;

const overlayKeyBoard = computed(() => store.state.keyBoard.enter);




watch(
  () => props.show,
  (value) => watchShow(value),
);
onMounted(() => watchShow(props.show));
onBeforeUnmount(() => reset());

const watchShow = (value) => {
  if (value) initial();
  else reset();
};

const initial = () => {
  if (overlayKeyBoard.value === OVERLAY_KEYBOARD.MODAL) {
    if (props.enterEvent)
      EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ENTER, onSubmit);
  } else {
    reset();
  }
};

const reset = () => {
  if (props.enterEvent) EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ENTER);
};

const onSubmit = () => emit("on:submit");

return (_ctx: any,_cache: any) => {
  const _component_BForm = _resolveComponent("BForm")!

  return (_openBlock(), _createBlock(_component_BForm, {
    onSubmit: _withModifiers(onSubmit, ["stop","prevent"])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["onSubmit"]))
}
}

})